module.exports = __webpack_public_path__ + "images/23ed4b5547841b17052fee07e961469213bf6696b4efac32c704f2dcd940f700.svg";